import { useCallback, useEffect, useState } from "react";
import { Container } from "./Container";
import { Table } from "./Table";
import {
    createLembaga,
    deleteLembaga,
    getAllLembaga,
    importLembaga,
    updateLembaga,
} from "../../../../Api/admin";
import { Modal, ModalBody, Modalfooter } from "../../../Modal";
import { Input } from "../../../Auth";
import Swal from "sweetalert2";
import "../../../../config.js";

export const Lembaga = () => {
    const [search, setSearch] = useState("");
    const [allData, setAllData] = useState([]);
    const [currentPage, setCurrentPage] = useState(1);
    const [createModal, setCreateModal] = useState(false);
    const [importModal, setimportModal] = useState(false);

    const [selectedFile, setSelectedFile] = useState(null);
    const [fileName, setFileName] = useState("Pilih File..");

    const [formType, setFormType] = useState("");
    const [lUsername, setLUsername] = useState("");
    const [lPassword, setLPassword] = useState("");
    const [lRole, setLRole] = useState("");
    const [lName, setLName] = useState("");
    const [lId, setLId] = useState(null);

    const getAllData = useCallback(async () => {
        let result = await getAllLembaga();
        let data = result.data.data;
        if (result?.status && result?.data) {
            setAllData(data);
        }
    }, []);

    const handleFileChange = (event) => {
        const file = event.target.files[0];
        setFileName(file.name);
        setSelectedFile(file);
    };

    const handleUploadClick = async () => {
        if (!selectedFile) {
            Swal.fire({
                title: "Info!",
                text: "Pilih file terlebih dahulu",
                icon: "info",
            });
            return;
        }

        const formData = new FormData();
        formData.append("file", selectedFile);

        try {
            let imported = await importLembaga(formData);
            if (imported && imported.success) {
                Swal.fire({
                    title: "Berhasil!",
                    text: imported.message,
                    icon: "success",
                }).then((a) => {
                    if (a.isConfirmed) {
                        getAllData();
                        setimportModal(false);
                        setSelectedFile(null);
                        setFileName("Pilih File.");
                    }
                });
            } else {
                Swal.fire({
                    title: "Gagal!",
                    text: imported.message,
                    icon: "info",
                });
            }
        } catch (error) {
            console.error("Kesalahan saat mengunggah file:", error);
            Swal.fire({
                title: "Gagal!",
                text: "Gagal mengunggah data",
                icon: "error",
            });
        }
    };

    const handleUserCreate = async () => {
        if (!lUsername.trim() || !lPassword.trim() || !lRole.trim()) {
            Swal.fire({
                title: "Peringatan!",
                text: "Username, Password dan Role wajib diisi!",
                icon: "warning",
            });
            return;
        }

        if (lRole === "admin" && lName.trim()) {
            Swal.fire({
                title: "Peringatan!",
                text: "Admin tidak boleh memiliki Nama Lembaga!",
                icon: "warning",
            });
            return;
        }

        if (lRole === "lembaga" && !lName.trim()) {
            Swal.fire({
                title: "Peringatan!",
                text: "Nama Lembaga wajib diisi untuk role Lembaga!",
                icon: "warning",
            });
            return;
        }

        let data = {
            username: lUsername,
            password: lPassword,
            role: lRole,
            school_name: lRole === "admin" ? null : lName,
        };

        try {
            let response;
            if (formType === "create") {
                response = await createLembaga(data);
                console.log(data);
            } else {
                data.id = lId;
                response = await updateLembaga(data);
            }

            if (response?.success) {
                Swal.fire({
                    title: "Berhasil!",
                    text: response.message,
                    icon: "success",
                }).then(() => {
                    setCreateModal(false);
                    getAllData();
                });
            } else {
                Swal.fire({
                    title: "Gagal!",
                    html: `${response?.message} <br><br> Beberapa kemungkinan: <br>- Username telah digunakan. <br>- Pastikan data yang diinput benar.`,
                    icon: "error",
                });
            }
        } catch (error) {
            console.error("Kesalahan saat menyimpan data:", error);
            Swal.fire({
                title: "Gagal!",
                text: "Terjadi kesalahan saat menyimpan data",
                icon: "error",
            });
        }
    };

    const handleUserdelete = async (id) => {
        Swal.fire({
            title: "Apakah Anda yakin?",
            text: "Anda tidak akan bisa mengembalikannya!",
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Ya, hapus!",
            cancelButtonText: "Tidak, batal!",
            reverseButtons: true,
            customClass: {
                confirmButton: "bg-red-500 text-white hover:bg-red-600",
                cancelButton: "bg-gray-300 text-black hover:bg-gray-400",
            },
        }).then(async (result) => {
            if (result.isConfirmed) {
                let deleted = await deleteLembaga(id);

                if (deleted && deleted?.success) {
                    Swal.fire("Dihapus!", deleted.message, "success");
                    getAllData();
                }
            } else if (result.dismiss === Swal.DismissReason.cancel) {
                Swal.fire("Dibatalkan", "", "error");
            }
        });
    };

    const filteredData = allData.filter(
        (item) =>
            item.username.toLowerCase().includes(search.toLowerCase()) ||
            (item.school_name &&
                item.school_name.toLowerCase().includes(search.toLowerCase()))
    );

    const itemsPerPage = 10;
    const totalPages = Math.ceil(filteredData.length / itemsPerPage);
    const displayedData = filteredData.slice(
        (currentPage - 1) * itemsPerPage,
        currentPage * itemsPerPage
    );

    const handlePrevPage = () => {
        if (currentPage > 1) setCurrentPage(currentPage - 1);
    };

    const downloadTemplateLembaga = () => {
        const fileURL =
            global.BASE_URL + "/certificates/users_import_template.xlsx";

        fetch(fileURL, { method: "HEAD" })
            .then((response) => {
                if (response.ok) {
                    const a = document.createElement("a");
                    a.href = fileURL;
                    a.download = "users_import_template.xlsx";
                    a.click();
                    Swal.fire(
                        "Di Unduh",
                        "Template berhasil di-download",
                        "success"
                    );
                } else {
                    Swal.fire("Error", "Data tidak ada", "error");
                }
            })
            .catch(() => {
                Swal.fire(
                    "Error",
                    "Terjadi kesalahan saat mengakses file",
                    "error"
                );
            });
    };

    const handleDownload = () => {
        Swal.fire({
            title: "Download Semua Data?",
            text: "Semua data akan di download dalam file berbentuk excel!",
            icon: "info",
            showCancelButton: true,
            confirmButtonText: "download",
            cancelButtonText: "batal",
            reverseButtons: true,
            customClass: {
                confirmButton: "bg-green-500 text-white hover:bg-green-600",
                cancelButton: "bg-red-500 text-white hover:bg-red-600",
            },
        }).then(async (result) => {
            if (result.isConfirmed) {
                const fileURL = global.BASE_URL + "/data/users/export";

                fetch(fileURL, { method: "HEAD" })
                    .then((response) => {
                        if (response.ok) {
                            const a = document.createElement("a");
                            a.href = fileURL;
                            a.download = "data.xlsx";
                            a.click();
                            Swal.fire(
                                "Di Unduh",
                                "Data berhasil di download",
                                "success"
                            );
                        } else {
                            Swal.fire("Error", "Data tidak ada", "error");
                        }
                    })
                    .catch(() => {
                        Swal.fire(
                            "Error",
                            "Terjadi kesalahan saat mengakses file",
                            "error"
                        );
                    });
            } else if (result.dismiss === Swal.DismissReason.cancel) {
                Swal.fire("Dibatalkan", "", "error");
            }
        });
    };

    const handleNextPage = () => {
        if (currentPage < totalPages) setCurrentPage(currentPage + 1);
    };

    const handleedituser = (user) => {
        setFormType("edit");
        setLUsername(user.username);
        setLPassword(user.password);
        setLName(user.school_name || "");
        setLRole(user.role);
        setLId(user.id);
        setCreateModal(true);
    };

    useEffect(() => {
        getAllData();
    }, [getAllData]);

    return (
        <Container>
            <div className="w-full flex flex-wrap justify-between items-center mb-3 mt-1 gap-2">
                <div>
                    <h3 className="text-lg font-semibold text-slate-800">
                        Data Lembaga
                    </h3>
                    <p className="text-slate-500">
                        List Semua Lembaga Yang Telah Terdaftar
                    </p>
                    <div className="mt-2 flex flex-row gap-1 flex-wrap">
                        <button
                            onClick={() => {
                                setFormType("create");
                                setLUsername("");
                                setLPassword("");
                                setLName("");
                                setLRole("");

                                setCreateModal(!createModal);
                            }}
                            className="py-1 px-3 bg-green-500 text-white rounded hover:bg-green-600">
                            Tambah Data
                        </button>
                        <button
                            onClick={() => {
                                setSelectedFile(null);
                                setimportModal(!importModal);
                            }}
                            className="py-1 px-3 bg-purple-500 text-white rounded hover:bg-purple-600">
                            Import Data
                        </button>
                        <button
                            onClick={handleDownload}
                            className="py-1 px-3 bg-blue-500 text-white rounded hover:bg-blue-600">
                            Download Data
                        </button>
                    </div>
                </div>

                <div className="lg:ml-3">
                    <div className="w-full max-w-sm min-w-[200px] relative">
                        <input
                            className="bg-white w-full pr-11 h-10 pl-3 py-2 text-slate-700 text-sm border border-slate-200 rounded shadow-sm focus:outline-none focus:border-slate-400 hover:border-slate-400"
                            placeholder="Cari Lembaga..."
                            value={search}
                            onChange={(e) => setSearch(e.target.value)}
                        />
                    </div>
                </div>
            </div>

            {importModal && (
                <Modal title="Import Data Lembaga" onClose={setimportModal}>
                    <ModalBody>
                        <div className="w-full h-full flex flex-col space-y-2">
                            <label
                                className="block text-sm font-medium text-gray-900 dark:text-white"
                                for="file_input">
                                Unggah File
                            </label>
                            <div className="relative w-full h-[48px]">
                                <input
                                    className="absolute inset-0 w-full h-full opacity-0 cursor-pointer"
                                    aria-describedby="file_input_help"
                                    id="file_input"
                                    type="file"
                                    accept=".xlsx"
                                    onChange={handleFileChange}
                                />
                                <div className="flex items-center justify-between h-full px-4 bg-gray-50 border border-gray-300 rounded-lg">
                                    <span className="text-sm text-gray-500">
                                        {fileName}
                                    </span>
                                    <button
                                        type="button"
                                        className="px-3 py-1 text-sm font-medium text-white bg-blue-500 rounded-lg hover:bg-blue-600 focus:ring-2 focus:ring-blue-500 focus:outline-none">
                                        Pilih
                                    </button>
                                </div>
                            </div>
                            <p
                                className="text-sm text-gray-500"
                                id="file_input_help">
                                Unggah file dalam format XLSX (Excel).
                            </p>
                            <button
                                onClick={() => downloadTemplateLembaga()}
                                className="w-full bg-purple-400 px-2 py-1 text-white border border-purple-500 hover:bg-purple-500 rounded">
                                unduh templat
                            </button>
                        </div>
                    </ModalBody>
                    <Modalfooter>
                        <button
                            onClick={handleUploadClick}
                            className="w-full bg-blue-400 px-3 py-2 text-white border border-blue-500 hover:bg-blue-500 rounded">
                            Upload
                        </button>
                    </Modalfooter>
                </Modal>
            )}

            {createModal && (
                <Modal
                    title={`Form ${
                        formType === "create" ? "Tambah" : "Perbarui"
                    } Data`}
                    onClose={setCreateModal}>
                    <ModalBody>
                        <Input
                            label="Nama Lembaga"
                            type="text"
                            value={lName}
                            onChange={(e) => setLName(e.target.value)}
                        />
                        <Input
                            label="Username"
                            type="text"
                            value={lUsername}
                            onChange={(e) => setLUsername(e.target.value)}
                        />
                        <Input
                            label="Password"
                            type="text"
                            value={lPassword}
                            onChange={(e) => setLPassword(e.target.value)}
                        />
                        <Input
                            label="Pilih Role"
                            type="select"
                            value={lRole}
                            onChange={(e) => setLRole(e.target.value)}
                            options={[
                                { value: "admin", label: "Admin" },
                                { value: "lembaga", label: "Lembaga" },
                            ]}
                        />
                    </ModalBody>
                    <Modalfooter>
                        <button
                            onClick={handleUserCreate}
                            className="w-full bg-blue-400 px-3 py-2 text-white border border-blue-500 hover:bg-blue-500 rounded">
                            {formType === "create" ? "Tambah" : "Perbarui"}
                        </button>
                    </Modalfooter>
                </Modal>
            )}

            <Table
                displayedData={displayedData}
                currentPage={currentPage}
                itemsPerPage={itemsPerPage}
                filteredData={filteredData}
                handleNextPage={handleNextPage}
                handlePrevPage={handlePrevPage}
                totalPages={totalPages}
                onUserEdit={handleedituser}
                onUserDelete={handleUserdelete}
            />
        </Container>
    );
};
